var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8034 8.65099C24.8968 4.05099 20.8568 0.597656 16.0034 0.597656C12.1501 0.597656 8.80342 2.78432 7.13675 5.98432C3.12342 6.41099 0.00341797 9.81099 0.00341797 13.931C0.00341797 18.3443 3.59008 21.931 8.00342 21.931L25.3368 21.931C29.0168 21.931 32.0034 18.9443 32.0034 15.2643C32.0034 11.7443 29.2701 8.89099 25.8034 8.65099ZM25.3368 19.2643L8.00342 19.2643C5.05675 19.2643 2.67008 16.8777 2.67008 13.931C2.67008 11.1977 4.71008 8.91765 7.41675 8.63766L8.84342 8.49099L9.51009 7.22432C10.7768 4.78432 13.2568 3.26432 16.0034 3.26432C19.4968 3.26432 22.5101 5.74432 23.1901 9.17099L23.5901 11.171L25.6301 11.3177C27.7101 11.451 29.3368 13.1977 29.3368 15.2643C29.3368 17.4643 27.5368 19.2643 25.3368 19.2643ZM13.3368 14.171L10.5501 11.3843L8.67008 13.2643L13.3368 17.931L21.3501 9.91765L19.4701 8.03766L13.3368 14.171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckIcon);
export default __webpack_public_path__ + "static/media/CloudCheckIcon.37c738b6.svg";
export { ForwardRef as ReactComponent };